// extracted by mini-css-extract-plugin
module.exports = {"shadow":"Card_shadow__YNoZM"};